module.exports = __webpack_public_path__ + "static/media/protective-shoes.2e71789b.jpg";